import React from "react";
import useDonationsForm from "../hooks/useDonationsForm";
import { CustomAmountForm } from "./CustomAmountForm";
import "../spinner.scss";
import "../utilities.scss";
import "./HelpTip.scss";

function AmountPresets({
  disabled,
  amounts,
  onClickAmount,
  frequency,
  selectedAmount,
}) {
  return amounts.map((amount) => {
    const suffix = frequency === "monthly" ? "/mo" : "";
    const isSelected = parseInt(selectedAmount, 10) === parseInt(amount, 10);

    return (
      <button
        key={amount}
        data-hook={`suggested-amount-${amount}`}
        className={`suggested-amount ${isSelected ? "is-selected" : ""}`}
        onClick={() => onClickAmount(amount)}
        disabled={disabled}
      >
        {`$${amount}${suffix}`}
      </button>
    );
  });
}

function DonationsForm({
  item,
  showEmptyHelpTip,
  countItems,
  countEmptyItems,
  isMiniCart,
  onClickDeleteItem,
  onClickSubmit,
  setEditStateItems,
  editStateItems,
  onSubmitItem,
  isLoading,
}) {
  const {
    onClickAmount,
    fixedValueAmounts,
    customAmountFocus,
    hasErrors,
    customAmountProps,
    frequency,
    selectedAmount,
    getValues,
    setCustomAmountFocus,
    setError,
    clearErrors,
    customAmount,
    isItemLoading,
    setIsLoadingCustomAmount,
    isLoadingCustomAmount,
    setItemPrice,
  } = useDonationsForm({
    item,
    isMiniCart,
    setEditStateItems,
    onSubmitItem,
  });

  const helpTip =
    countEmptyItems > 0 && countEmptyItems === countItems ? (
      <>To continue, select a gift amount.</>
    ) : countEmptyItems < countItems ? (
      <>To continue, select an amount or remove gift.</>
    ) : (
      <></>
    );

  return (
    <div
      className={`order-item__wrapper order-item__wrapper--edit-donation content-blur coh-style-container-theme---dark-1${
        (isMiniCart && " order-item--mini") || ""
      }${
        (isLoading && " spinner--after spinner--centered content-blurred") || ""
      }`}
    >
      <div className="order-item order-item--edit-donation">
        {(!isMiniCart && (
          <h4 className="order-item__title order-item__title--edit-donation">
            {item.attributes.title}
          </h4>
        )) ||
          null}

        {showEmptyHelpTip ? (
          <div className="help-tip help-tip--bottom-left help-tip--item-amount">
            {helpTip}
          </div>
        ) : null}
        <div className="order-item-form__amount">
          {fixedValueAmounts ? (
            <div
              className={`suggested-amount-wrapper ${
                customAmountFocus ? "is-editing" : ""
              }`}
            >
              <AmountPresets
                amounts={fixedValueAmounts}
                frequency={frequency}
                onClickAmount={onClickAmount}
                selectedAmount={selectedAmount}
                disabled={isItemLoading}
              ></AmountPresets>
            </div>
          ) : null}

          <CustomAmountForm
            {...customAmountProps}
            item={item}
            onClickSubmit={onClickSubmit}
            isMiniCart={isMiniCart}
            customAmountFocus={customAmountFocus}
            setCustomAmountFocus={setCustomAmountFocus}
            onSubmitItem={onSubmitItem}
            setError={setError}
            customAmount={customAmount}
            clearErrors={clearErrors}
            isLoadingCustomAmount={isLoadingCustomAmount}
            setIsLoadingCustomAmount={setIsLoadingCustomAmount}
            setItemPrice={setItemPrice}
            setEditStateItems={setEditStateItems}
            editStateItems={editStateItems}
          />

          {(isMiniCart && (
            <button
              type="submit"
              disabled={hasErrors}
              data-hook="give-now-btn"
              className="order-item__button--submit coh-style-link-button-with-icon"
              onClick={() => {
                const values = getValues();
                const customAmount = values[`donation_amount${item.id}`];

                onClickSubmit(
                  customAmountFocus ? customAmount : selectedAmount
                );
              }}
            >
              Give Now
            </button>
          )) ||
            null}
        </div>

        {(!isMiniCart && (
          <button
            className="order-item__delete-button order-item__delete-button--edit-donation"
            onClick={() => onClickDeleteItem(item)}
          >
            <span className="visually-hidden">
              Remove {item.attributes.title} from cart
            </span>
            <span aria-hidden>×</span>
          </button>
        )) ||
          null}
      </div>
    </div>
  );
}

export default DonationsForm;
